import { z } from "zod";
import { AssetReference } from "../dsm/assets/asset-reference";
import { Brand } from "../dsm/brand";
import { DocumentationPageContent } from "../dsm/documentation/page-content";
import { DocumentationComment, DocumentationCommentThread } from "../dsm/documentation/thread";
import { DesignElement } from "../dsm/elements/raw-element";
import { ElementPropertyDefinition } from "../dsm/properties/property-definition";
import { ElementPropertyValue } from "../dsm/properties/property-value";
import { DesignSystemVersion } from "../dsm/version";
import { ElementViewColumn } from "../dsm/views/column";
import { ElementView } from "../dsm/views/view";
import { DocumentationPageRoom } from "../liveblocks";
import { PublishedDocsDump } from "./published-docs-dump";

export const DocumentationThreadDump = z.object({
  thread: DocumentationCommentThread,
  comments: DocumentationComment.array(),
});

export const DocumentationPageRoomDump = z.object({
  room: DocumentationPageRoom,
  threads: DocumentationThreadDump.array(),
});

export const DesignSystemVersionMultiplayerDump = z.object({
  documentationPages: DocumentationPageRoomDump.array(),
});

export const DesignSystemVersionDump = z.object({
  version: DesignSystemVersion,
  brands: Brand.array(),
  elements: DesignElement.array(),
  elementPropertyDefinitions: ElementPropertyDefinition.array(),
  elementPropertyValues: ElementPropertyValue.array(),
  elementViews: ElementView.array(),
  elementColumns: ElementViewColumn.array(),
  documentationPageContents: DocumentationPageContent.array(),
  documentationPageRooms: DocumentationPageRoomDump.array(),
  publishedDocumentations: PublishedDocsDump.array(),
  assetReferences: AssetReference.array(),
});

export type DocumentationThreadDump = z.infer<typeof DocumentationThreadDump>;
export type DocumentationPageRoomDump = z.infer<typeof DocumentationPageRoomDump>;
export type DesignSystemVersionDump = z.infer<typeof DesignSystemVersionDump>;
